import {
  getNCRSummary as apiGetNCRSummary,
  getNCRList as apiGetNCRList,
  getNCRDetail as apiGetNCRDetail,
  submitMakerResponse as apiSubmitMakerResponse,
  getMyPending as apiGetMyPending,
  createNCR as apiCreateNCR,
  checkerVerifyNCR as apiCheckerVerifyNCR,
  downloadNCRClosedReport as apiDownloadNCRClosedReport,
  getProjectHeadPendingNCRs as apiGetProjectHeadPendingNCRs,
  projectHeadSignNCR as apiProjectHeadSignNCR,
  getNCRFilterOptions as apiGetNCRFilterOptions,
} from "../api";

export const getNCRSummary = async (params) => {
  const res = await apiGetNCRSummary(params);
  return res.data;
};

export const getNCRList = async (params = {}) => {
  const queryParams = { ...params };
  if (!queryParams.page) queryParams.page = 1;
  if (!queryParams.page_size && !queryParams.pageSize) queryParams.page_size = 15;
  if (queryParams.pageSize) {
    queryParams.page_size = queryParams.pageSize;
    delete queryParams.pageSize;
  }
  if (queryParams.status === "all") {
    delete queryParams.status;
  }

  const res = await apiGetNCRList(queryParams);
  const isArray = Array.isArray(res.data);
  return {
    data: isArray ? res.data : res.data.results || [],
    total: isArray ? res.data.length : res.data.count || 0,
    page: queryParams.page,
    pageSize: queryParams.page_size,
  };
};

export const getNCRDetail = async (id) => {
  const res = await apiGetNCRDetail(id);
  return res.data;
};

export const submitMakerResponse = async (id, formData) => {
  const res = await apiSubmitMakerResponse(id, formData);
  return res.data;
};

export const getMyPending = async (params = {}) => {
  const queryParams = { role: "maker", ...params };
  if (!queryParams.page) queryParams.page = 1;
  if (!queryParams.page_size && !queryParams.pageSize) queryParams.page_size = 15;
  if (queryParams.pageSize) {
    queryParams.page_size = queryParams.pageSize;
    delete queryParams.pageSize;
  }
  const res = await apiGetMyPending(queryParams);
  const isArray = Array.isArray(res.data);
  return {
    data: isArray ? res.data : res.data.results || [],
    total: isArray ? res.data.length : res.data.count || 0,
    page: queryParams.page,
    pageSize: queryParams.page_size,
  };
};

export const createNCR = async (formData) => {
  const res = await apiCreateNCR(formData);
  return res.data;
};

export const checkerVerifyNCR = async (id, formData) => {
  const res = await apiCheckerVerifyNCR(id, formData);
  return res.data;
};

export const downloadNCRClosedReport = async (id, params = {}) => {
  return apiDownloadNCRClosedReport(id, params);
};
export const downloadNCRReport = downloadNCRClosedReport;

export const getProjectHeadPendingNCRs = async (params = {}) => {
  const queryParams = { ...params };
  if (!queryParams.page) queryParams.page = 1;
  if (!queryParams.page_size && !queryParams.pageSize) queryParams.page_size = 15;
  if (queryParams.pageSize) {
    queryParams.page_size = queryParams.pageSize;
    delete queryParams.pageSize;
  }
  const res = await apiGetProjectHeadPendingNCRs(queryParams);
  const isArray = Array.isArray(res.data);
  return {
    data: isArray ? res.data : res.data.results || [],
    total: isArray ? res.data.length : res.data.count || 0,
    page: queryParams.page,
    pageSize: queryParams.page_size,
  };
};

export const projectHeadSignNCR = async (id, formData) => {
  const res = await apiProjectHeadSignNCR(id, formData);
  return res.data;
};

export const getNCRFilterOptions = async (params) => {
  const res = await apiGetNCRFilterOptions(params);
  return res.data;
};
